import { Box, Typography, Stack, Button } from '@mui/material'
import { useIsMobile } from '@/hooks/Responsive'
import APIVisualPC from './APIVisualPC'
import APIVisualMO from './APIVisualMO'
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

export default function APISection() {
  const { isMobile } = useIsMobile()
  const lang = useLang() 

  return (
    <Box
      sx={{
        mx: 'auto',
        py: isMobile ? 10 : 15,
        width: '100%',
        maxWidth: '1440px',
        minHeight: isMobile ? 'initial' : 'calc(100vh - 120px)',
        px: 2,
      }}
    >
      <Stack
        alignItems="center"
        sx={{
          width: '100%',
          bgcolor: '#120125',
          borderRadius: '20px',
          overflow: 'hidden',
          pt: isMobile ? 7 : 12,
          pb: isMobile ? 5 : 9,
          px: 2,
          textAlign: 'center',
        }}
      >
        <Typography component="h3" color="primary.main" variant={isMobile ? 'h5' : 'h4'}>공유플랫폼 API</Typography>
        <Typography component="p" color="text.contrastText" sx={{ lineHeight: 1.7, mt: 2 }}>
          OpenVLab은 대학, 평생교육기관, 직업교육기관 등 다양한 기관이 보유한 학습 콘텐츠를 공유하는 방식으로 운영됩니다.<br />
          콘텐츠를 제공하고자 하는 기관은 OpenVLab에서 제공하는 API를 통해 자체 LMS와 연동하여 콘텐츠를 제공하게 됩니다.
        </Typography>
        {/* <Button 
          component={RouterLink}
          to={buildLangHref('/alarm/api', lang)}
          size="medium" 
          variant="contained" 
          sx={{ 
            bgcolor: 'background.paper', 
            color: 'text.primary',
            mt: 5, 
            '&:hover': { 
              bgcolor: 'grey.50' 
            } 
          }}
        >
          자세히 보기
        </Button> */}
        <Box
          sx={{
            width: '100%',
            maxWidth: isMobile ? '395px' : '1000px',
            bgcolor: '#120125',
            '& svg': {
              width: '100%',
              mx: 'auto',
              height: 'auto',
              display: 'block',
            }
          }}
        >
          {isMobile ? (
            <APIVisualMO />
          ) : (
            <APIVisualPC />
          )}
        </Box>
      </Stack>
    </Box>
  )
}